// extracted by mini-css-extract-plugin
export default {"vbBtn":"fBHCe__vbBtn","btnPrimary":"WYhHH__btnPrimary","btnSecondary":"VK1jW__btnSecondary","btnWhite":"CHYv6__btnWhite"};